/**
 * 渲染方式基类
 */
export class Renderer {
    /**
     * 根据矢量要素获取渲染符号
     * @param {ScreenBounds} redrawBounds - 屏幕范围
     * @remark Do something before layer draw, etc ClusterRenderer
     */
    init(redrawBounds) {
        //do something before layer draw; 
        //etc ClusterRenderer
    }
}
